import { render } from "./feature-update.vue?vue&type=template&id=57120f83"
import script from "./feature-update.vue?vue&type=script&lang=js"
export * from "./feature-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__